export default "__VITE_ASSET__C4m8_l9q__"